import React from 'react';
import { Stack, Text } from '@moda/om';
import { colors } from '@moda/tokens';
import AlertIcon from '@moda/icons/warning-16';
import { FulfillmentTypes } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { useUser } from '../../../hooks/useUser';
import { LineItemReturnPolicy } from '../LineItemReturnPolicy';
import { LineItemMiniGranularity } from '../LineItemMini';

import './LineItemShippingDetails.scss';

type Props = {
  granularity?: LineItemMiniGranularity;
  item: LineItem;
};

export const LineItemShippingDetails: React.FC<Props> = ({
  granularity = LineItemMiniGranularity.Full,
  item: {
    attributes: {
      expectedDeliveryTime,
      returnPolicy,
      returnPolicyCode,
      isAvailableNow,
      fulfilmentType,
      customerDeliveryNotes
    }
  }
}) => {
  const isDropshipItem =
    fulfilmentType === FulfillmentTypes.DropShip || fulfilmentType === FulfillmentTypes.Fulfillment;
  const { user } = useUser();
  const consignmentAlert =
    user.affiliate === 1 &&
    (fulfilmentType === FulfillmentTypes.DropShip ||
      fulfilmentType === FulfillmentTypes.MiraklEconcession ||
      fulfilmentType === FulfillmentTypes.MiraklDropship);
  const expectedDeliveryReworded = expectedDeliveryTime?.replace(/^\w+.*:/, 'Shipping est. ');
  const adjustedExpectedDeliveryTime = expectedDeliveryReworded;
  const showExpectedDeliveryTime =
    Boolean(expectedDeliveryTime) && !isAvailableNow && !(isDropshipItem && customerDeliveryNotes);

  return (
    <Stack space={4}>
      {showExpectedDeliveryTime && <Text>{adjustedExpectedDeliveryTime}</Text>}

      {granularity === LineItemMiniGranularity.Full && (
        <LineItemReturnPolicy returnPolicy={returnPolicy} returnPolicyCode={returnPolicyCode} />
      )}

      {!isAvailableNow && (
        <div>
          RESERVE TODAY
          <div>
            An advance payment of 50% is required at checkout.
            {granularity === LineItemMiniGranularity.Full &&
              ' The remaining balance will be charged when the item ships.'}
          </div>
        </div>
      )}
      {consignmentAlert && (
        <Stack space={2} direction="horizontal" alignItems="center">
          <AlertIcon color={colors.all['code-red']} />
          <Text color="code-red">Ineligible for consignment orders</Text>
        </Stack>
      )}
    </Stack>
  );
};
